// extracted by mini-css-extract-plugin
export default {"InfoboxModule":"InfoboxModule_eovOd","InfoboxModule_item":"InfoboxModule_item_cHTOU"};